<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="error-win">
      <header>网络异常</header>
      <p class="code">服务器请求失败，请点击刷新重试<br>错误码：["{{errorCode}}"]</p>
      <div class="bottom-btn">
        <div class="close-page" @click="_close_page">关闭页面</div>
        <div class="refresh-page" @click="_refresh">刷新</div>
      </div>
    </div>
  </div>
</template>

<script>
import appBridge from '@/config/appBridge'
import ModalMask from '@/components/modal/ModalMask'

export default {
  name: 'ErrorWin',

  components: {
    ModalMask
  },
  data () {
    return {
      showing: false
    }
  },
  methods: {
    show (errorCode) {
      this.showing = true
      this.errorCode = errorCode
    },
    _close_page () {
      this.showing = false
      appBridge.closeWebView()
    },
    _refresh () {
      // this.$router.go(0)  iOS不支持
      window.location.reload()
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .error-win {
    width: 30.7rem;
    height: 18.5rem;
    text-align: center;
    background-color: @modal-win-bg-color;
    .modal-common;
    /* .modal-anim; */
  }
  header {
    font-size: 1.7rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFF;
    line-height: 2.7rem;
    margin: 2.3rem 0 1.1rem 0;
    text-align: center;
  }
  .code {
    font-size: 1.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ACB4C4;
    line-height: 2.4rem;
  }
  .bottom-btn {
    display: flex;
    height: 4.6rem;
    position: absolute;
    bottom: 0;
    border-top: 0.1rem solid #5C6280;
    width: 100%;
  }
  .close-page {
    flex-grow: 1;
    font-size: 1.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ACB4C4;
    line-height: 4.6rem;
    width: 50%;
    border-right: 0.1rem solid #5C6280;
  }
  .refresh-page {
    flex-grow: 1;
    font-size: 1.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #00D176;
    line-height: 4.6rem;
    width: 50%;
  }
</style>
